import Editor from "@monaco-editor/react";
import { useRef} from "react";
import { baseURL } from "./Config/settings";
import { defineTheme } from "./themes";
import { userContext } from "./App";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import { useState } from "react";
import "./Components/CSS/CustomEditor.css";

const monacoThemes = ['active4d', 'all-hallows-eve', 'amy', 'birds-of-paradise', 'blackboard', 'brilliance-black', 'brilliance-dull', 'chrome-devtools', 'clouds-midnight', 'clouds', 'cobalt', 'dawn', 'dreamweaver', 'eiffel', 'espresso-libre', 'github', 'idle', 'katzenmilch', 'kuroir-theme', 'lazy', 'magicwb--amiga-', 'merbivore-soft', 'merbivore', 'monokai-bright', 'monokai', 'night-owl', 'oceanic-next', 'pastels-on-dark', 'slush-and-poppies', 'solarized-dark', 'solarized-light', 'spacecadet', 'sunburst', 'textmate--mac-classic-', 'tomorrow-night-blue', 'tomorrow-night-bright', 'tomorrow-night-eighties', 'tomorrow-night', 'tomorrow', 'twilight', 'upstream-sunburst', 'vibrant-ink', 'xcode-default', 'zenburnesque', 'iplastic', 'idlefingers', 'krtheme', 'monoindustrial']

const CustomEditor = ({language, tag, fontSize, monacoRef, theme:givenTheme, code, setCode, setOutput, presetCode, userCode}) => {
    const {user, setUser} = useContext(userContext)
    const { id } = useParams()
    const [result, setResult] = useState('The output of code is shown here')

    const editorRef = useRef(null)
    
    const handleEditorWillMount = (monaco) => {
        monacoThemes.map(theme => defineTheme(theme))
    }

    const handleEditorDidMount = (editor, monaco) => {
        monacoRef.current = monaco
        editorRef.current =  editor
        monaco.editor.setTheme('vs-dark')
    }

    const handleSubmission = () => {
        fetch(`${baseURL}/rce/python/`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "email": user.email,
                "code": editorRef.current.getValue(),
                "id": id
            })
        })
        .then(response => response.json())
        .then(data => {
            setOutput(data)
            setResult(data)
        })
    }

    const handleReset = () => {
        editorRef.current.setValue(presetCode)
    }

    return (
        <>
            <button style={{textAlign: "center", width: "100px", height: "25px", color: "white", background: "#021D36", marginLeft: "20px", boxSizing: 'border-box'}} onClick={() => handleSubmission()}>Submit</button>
            <button style={{textAlign: "center", width: "100px", height: "25px", color: "white", background: "#021D36", marginLeft: "20px", boxSizing: 'border-box'}} onClick={() => handleReset()}>Reset</button>
            <div className="main-editor-container">
                <Editor
                height="100%"
                width="100%"
                language={language}
                value={userCode === null || userCode === undefined ? presetCode : userCode}
                onMount={handleEditorDidMount}
                beforeMount={handleEditorWillMount}
                options={{fontSize: fontSize, formatOnPaste: true, formatOnType: true}}
                />
           </div>
        </>
    )
}

export default CustomEditor
